import { gql } from "@apollo/client";

export const UPDATE_CASE_STATUS = gql`
  mutation UpdateCaseStatus($data: UpdateCaseStatusInputData!) {
    updateCaseStatusById(data: $data) {
      id
      caseNumber
      orgId
      status
      createdAt
      updatedAt
      referral {
        id
        from
        user {
          id
          firstName
          lastName
          country
          avatarUrl
          isDeleted
          email
          gender
          employmentStatus
          disability
          dob
          housingStatus
          incomeLevel
          insurance
          household
          createdAt
          updatedAt
          phone
          ext
          verified
        }
        userId
        eligibilityStatus
        serviceId
        serviceName
        orgId
        status
        isSelfReferral
      }
    }
  }
`;
